import api from '../api'

export default {
  props: {
    data: {
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  created () {
    this.load()
  },
  data () {
    return {
      loading: null,
      values: [],
      value: null,
      clearDefault: false,
      target: null,
      placeholder: null
    }
  },
  watch: {
    data () {
      if (!this.data || !this.data.value || this.target !== api.dimension.uniqueName(this.data.value)) {
        this.loading = null
      }
      this.load().then(this.updateDefault)
    }
  },
  methods: {
    load () {
      if (this.loading === null) {
        this.placeholder = api.dimension.name(this.data.value)
        this.target = api.dimension.uniqueName(this.data.value)
        this.loading = this.$store.dispatch(
          'customGraph/loadValues',
          api.dimension.uniqueName(this.data.value)
        ).then(() => {
          this.values.splice(0, this.values.length, ...this.$store.getters['customGraph/dimension'](
            api.dimension.uniqueName(this.data.value)
          ).values)
        })
      }
      return this.loading
    },
    reset () {
      this.value.splice(0)
    },
    setValues () {
      return Promise.resolve()
    },
    async updateDefault () {
      if (!this.clearDefault) {
        await this.setValues(this.data.defaultValues, false)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/macarons-graphs-front/src/filter/filter.js